<template>
  <div class="atualizar_registros">
    <div class="atualizar_registros_body">
      <div class="row">
        <div class="col-6">
          <label for="tipos"
                 class="label">Escolha o tipo de registro:</label>
          <div id="tipos"
               class="d-inline-flex justify-content-between w-100">
            <button v-for="(tipo, index) in tipos"
                    :key="index"
                    class="btn btn_tipo text-capitalize mr-3"
                    :class="{'btn_tipo_selected': formData.tipo_registro == tipo.value,
                             'btn_tipo_error': tipoInvalid && !formData.tipo_registro}"
                    @click="formData.tipo_registro == tipo.value ? formData.tipo_registro = null : formData.tipo_registro = tipo.value">
              <IconSvg :id="tipo.icon"
                       :icon="tipo.icon"
                       class="icon_tipo icon--md mb-1" /><br>
              <span v-for="(word, i) in tipo.text.split(' ')"
                    :key="i">
                {{ word }}
              </span>
            </button>
          </div>
          <small v-if="tipoInvalid && !formData.tipo_registro"
                 class="text-danger">
            Seleção obrigatória
          </small>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-6">
          <label for="data_registro"
                 class="label p-0 m-0 mb-1">Data do registro</label>
          <div id="data_registro"
               class="d-inline-flex justify-content-between align-items-center">
            <div class="d-inline-flex justify-content-between align-items-center">
              <input v-model="formData.data_inicial"
                     v-validate="'required'"
                     type="date"
                     name="data_inicial"
                     class="form-control form-control-sm"
                     :class="{'is-invalid' : errors.has('data_inicial')}">
              <small class="invalid-feedback"> Campo obrigátorio </small>
              <p class="m-0 px-2">
                até
              </p>
              <input v-model="formData.data_final"
                     v-validate="'required'"
                     type="date"
                     name="data_final"
                     class="form-control form-control-sm"
                     :class="{'is-invalid' : errors.has('data_final')}">
              <small class="invalid-feedback"> Campo obrigátorio </small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 m-0 p-0 mt-2">
        <hr class="hr_atualizar_registros">
        <div class="col-12 d-flex justify-content-end m-0 p-0">
          <button class="btn btn-sm btn-secondary"
                  @click="atualizarRegistros">
            Descer registros
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import AtualizarRegistrosService from '@/services/Registros/AtualizarRegistros'

  export default {
    name: 'AtualizarRegistros',
    data () {
      return {
        tipos: [
          {icon: 'nascimento', text: 'nascimento', value: 'N'},
          {icon: 'engagement', text: 'casamento', value: 'C'},
          {icon: 'flower', text: 'óbito', value: 'O'},
        ],
        formData: {
          tipo_registro: null,
          data_inicial: null,
          data_final: null,
        },
        tipoInvalid: false
      }
    },
    methods: {
      async atualizarRegistros () {
        const valid = await this.$validator.validate()

        if (!this.formData.tipo_registro) {
          this.tipoInvalid = true
          return
        } else this.tipoInvalid = false

        if (!valid) return

        try {
          loader({active: true})

          const response = await AtualizarRegistrosService.descerRegistrosCrc(this.formData)

          return displayMessage('error', 'Sucesso!', response.message)
        } catch (error) {
          let errorMessage = error.response.data.message

          if (!errorMessage) {
            errorMessage = 'Não foi possível atualizar os registros, favor entrar em contato com o suporte.'
          }

          return displayMessage('error', 'Erro', errorMessage)
        } finally {
          loader({active: false})
        }
      }
    }
  }
</script>
<style lang="scss" scoped>

  .atualizar_registros {
    &_alert {
      font-size: 18px;
      font-weight: 500;
      color: #000000;
    }

    &_btn {
      border: 1px solid #707070;
      text-align: right;
    }
  }

  .btn_tipo {
    min-width: 100px;
    min-height: 80px;
    background: #FFFFFF;
    border: 1px solid #696969;
    border-radius: 0;
    color: #696969;
    font-weight: 500;
    font-size: 16px;
    padding: 0;
    line-height: 1;

    &_selected {
      background: #086aae;
      color: #FFFFFF;
      box-shadow: none;
      border: 1px solid #086aae;
    }

    &_selected svg {
      stroke-width: 0;
    }

    &_error {
      border: 1px solid #FF0000;
    }
  }

  .btn_tipo span:not(:last-child) {
    font-size: 14px;
    font-weight: 300;
  }

  .icon_tipo {
    fill: #FFFFFF;
    stroke: #696969;
    stroke-width: 0.5px;
    transition: 0.3s;
  }

</style>
